import { __extends } from "tslib";
import { addClass, getShadowElement, removeClass } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { BADGE_CONSTANTS } from './badge-constants';
var BadgeAdapter = /** @class */ (function (_super) {
    __extends(BadgeAdapter, _super);
    function BadgeAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(component, BADGE_CONSTANTS.selectors.ROOT);
        return _this;
    }
    BadgeAdapter.prototype.setRootClass = function (classes) {
        addClass(classes, this._rootElement);
    };
    BadgeAdapter.prototype.removeRootClass = function (classes) {
        removeClass(classes, this._rootElement);
    };
    return BadgeAdapter;
}(BaseAdapter));
export { BadgeAdapter };
